//* node modules
import { Link } from "react-router-dom";

//*images
import sliderImageDesktop from "../../../../assets/images/CareerPlus-KV-Web-Slider-Contact.svg";
import sliderImageMobile from "../../../../assets/images/CareerPlus-KV-Web-Slider-428x926.jpg";

//*Style files
import "./index.scss";

const CareerPlusWebSliderSection = (props) => {
  return (
    <section className="position-relative">
      <img
        src={window.innerWidth < 768 ? sliderImageMobile : sliderImageDesktop}
        alt="CareerPlus-KV-Web-Slider"
        width="100%"
      />
      <div className="apply-now-btn-banner d-flex align-items-center justify-content-center">
        <Link to="/application">APPLY NOW</Link>
      </div>
    </section>
  );
};

export default CareerPlusWebSliderSection;
